<template>
  <div class="help-content">
    <ul class="nav">
      <li class="nav-item">
        <img class="icon-tb" src="@/assets/images/14tb.png" alt="" />
        <span @click.prevent="scrollToAnchor('help1')">
          如何下载安装电子书？
        </span>
      </li>
      <li class="nav-item">
        <img class="icon-tb" src="@/assets/images/14tb.png" alt="" />
        <span @click.prevent="scrollToAnchor('help2')">如何激活电子书？</span>
      </li>
      <li class="nav-item">
        <img class="icon-tb" src="@/assets/images/14tb.png" alt="" />
        <span @click.prevent="scrollToAnchor('help3')">
          如果选错书了怎么办？
        </span>
      </li>
      <li class="nav-item">
        <img class="icon-tb" src="@/assets/images/14tb.png" alt="" />
        <span @click.prevent="scrollToAnchor('help4')">如何获得激活码？</span>
      </li>
      <li class="nav-item">
        <img class="icon-tb" src="@/assets/images/14tb.png" alt="" />
        <span @click.prevent="scrollToAnchor('help5')">
          更多问题请关注微信。
        </span>
      </li>
      <li class="nav-item">
        <img class="icon-tb" src="@/assets/images/14tb.png" alt="" />
        <span @click="openPrivacyPolicy()">隐私政策说明。</span>
      </li>
    </ul>
    <div class="main">
      <router-view></router-view>
      <!-- <help-content v-show="isHelp"></help-content>
      <privacy-policy v-show="!isHelp"></privacy-policy> -->
    </div>
  </div>
</template>

<script>
import HelpContent from "./HelpContent.vue";
import PrivacyPolicy from "./PrivacyPolicy.vue";
export default {
  name: "Help",
  components: { HelpContent, PrivacyPolicy },
  props: {},
  data() {
    return {
      isHelp: true,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    scrollToAnchor(anchor) {
      this.$router.replace({
        path: "/main/help/question/" + anchor,
      });
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    openPrivacyPolicy() {
      this.$router.replace({
        path: "/main/help/agreement",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.help-content {
  width: 1002px;
  margin: 0 auto;
  display: flex;

  .nav {
    width: 212px;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.5);
    padding: 26px 0;
    position: relative;
    z-index: 9;
    &-item {
      padding: 10px 0 10px 20px;
      height: 36px;
      overflow: hidden;
      .icon-tb {
        width: 17px;
        height: 16px;
        float: left;
      }
      span {
        float: left;
        font-size: 12px;
        color: #000;
        line-height: 16px;
        margin-left: 20px;
        cursor: pointer;
        &:hover {
          color: #093;
          text-decoration: underline;
        }
      }
    }
  }

  .main {
    flex: 1;
    background: white;
    padding: 16px 60px 0 30px;
    /deep/.section {
      padding: 20px;
      h3 {
        font-size: 24px;
        color: #090;
        line-height: 1.5em;
        .toTop {
          font-size: 12px;
          color: #000;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      h4 {
        font-size: 18px;
        color: #000;
        margin: 20px 0;
        line-height: 1.5em;
      }
      .paragraph1 {
        font-size: 16px;
        color: #666;
        line-height: 2em;
      }
      .img-wrap {
        img {
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
